import Vue from 'vue'
import {
    ValidationObserver,
    ValidationProvider,
    extend
} from "vee-validate";
import { cpf } from 'cpf-cnpj-validator';
import { cnpj } from 'cpf-cnpj-validator';

import { required, email, min, max, regex } from 'vee-validate/dist/rules';


extend('required', {
    ...required,
    message: 'Campo obrigatório'
});

extend('max', {
    ...max,
    message: 'Valor inválido'
});

extend('email', {
    ...email,
    message: 'E-mail inválido'
});

extend('min', {
    ...min,
    message: "Valor inválido",
});

extend('regex', regex);
extend('regex', {
    ...regex,
    message: 'Contém caractere(s) inválido(s)'
});

extend('cpf', {
    validate: value => cpf.isValid(value, true),
    message: 'CPF inválido'
});

extend('cnpj', {
    validate: value => cnpj.isValid(value, true),
    message: 'CNPJ inválido'
});

// Install VeeValidate components globally
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);


// WEBPACK FOOTER //
// ./src/vee-validate.js